import { makeAutoObservable } from 'mobx';

class ZakazStore {
    constructor() {
        makeAutoObservable(this);
    }

    // Add your store methods and observables here
}

export default new ZakazStore(); 